import classes from './DotsLoader.module.scss';

type DotsLoaderProps = {
  label?: string;
};

export const DotsLoader = ({ label }: DotsLoaderProps) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.dots}>
        <span className={classes.dot1} />
        <span className={classes.dot2} />
        <span className={classes.dot3} />
      </div>
      {label && <p className={classes.label}>{label}</p>}
    </div>
  );
};
